import { render, staticRenderFns } from "./BlacklistList.vue?vue&type=template&id=15dc87e4&"
import script from "./BlacklistList.vue?vue&type=script&lang=js&"
export * from "./BlacklistList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports